import { onceEach } from "./once.js";

import tablesort from "tablesort";
import "tablesort/src/sorts/tablesort.number.js";
import "tablesort/src/sorts/tablesort.date.js";

const scan = (document) => {
  onceEach(document.querySelectorAll("table[data-sortable]"), "data-sortable", (e) => {
    tablesort(e, {});

    /* If the immediate child is an A, give it an HREF attribute to be in the taborder and have
       it emit "click" */
    e.querySelectorAll("th > a:not([href])").forEach((a) => {
      a.href = "";
      a.addEventListener("click", (ev) => {
        /* don't navigate to "" */
        ev.preventDefault();
      });
    });

    // After initialization, check if any column has data-sort-default AND data-sort-reverse
    // If so, trigger a second click to flip from ascending to descending
    const defaultSortHeader = e.querySelector("th[data-sort-default]");
    if (defaultSortHeader && defaultSortHeader.hasAttribute("data-sort-reverse")) {
      // The library will have already sorted ascending, so click again for descending
      setTimeout(() => {
        defaultSortHeader.click();
      }, 0);
    }
  });
};

document.addEventListener("DOMContentLoaded", () => scan(document));
document.addEventListener("partial:replace", (ev) => scan(ev.container));
